import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import PlayfairCipherEncryption from './PlayfairCipherEncryption';
import PlayfairCipherDecryption from './PlayfairCipherDecryption';
import PlayfairTable from './PlayfairTable';
import CustomButton from '../CustomButton';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';



const PlayfairCipherSimulation = () => {
    var encStepsList = []
    var decStepsList = []
    var kTab = []
    const [finalResult, setResult] = useState("")
    const [originalPlainText, setOriginalPlainText] = useState("")
    const [decryptedResult, setDecryptedtResult] = useState("")
    const [key, setKey] = useState("")
    const [clickedSimulate, setClickedSimulate] = useState(false)
    const [keyTable, setKeyTable] = useState([])
    const [encSteps, setEncSteps] = useState([])
    const [decSteps, setDecSteps] = useState([])
    const [isSimulating, setIsSimulating] = useState(false);

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function addEncStep(step) {
        const newList = encStepsList.concat([{ "value": step }]);
        encStepsList = newList;
        // console.log("Added to EncSteps : ", newList)
        setEncSteps(newList)
    }

    function addDecStep(step) {
        const newList = decStepsList.concat([{ "value": step }]);
        decStepsList = newList;
        // console.log("Added to Dec Steps : ", newList)
        setDecSteps(newList)
    }

    function generateKeyTable(key, ks, keyT) {
        let i, j, k, flag = 0;

        // a 26 character hashmap
        // to store count of the alphabet
        let dicty = new Array(26).fill(0);
        for (i = 0; i < ks; i++) {
            let r = key[i].charCodeAt(0) - 65;

            if (key[i] !== 'J') {
                dicty[r] = 2;
            }

        }

        dicty['J'.charCodeAt(0) - 65] = 1;
        i = 0;
        j = 0;

        for (k = 0; k < ks; k++) {
            let r = key[k].charCodeAt(0) - 65;
            if (dicty[r] === 2) {
                dicty[r] -= 1;
                keyT[i][j] = key[k];
                j++;
                if (j === 5) {
                    i++;
                    j = 0;
                }
            }
        }

        for (k = 0; k < 26; k++) {
            if (dicty[k] === 0) {
                keyT[i][j] = String.fromCharCode(k + 65);
                j++;
                if (j === 5) {
                    i++;
                    j = 0;
                }
            }
        }
        console.log(keyT);
        setKeyTable(keyT)
        kTab = keyT;
        return keyT;
    }

    // *** Encryption START ***

    // Function to search for the characters of a digraph
    // in the key square and return their position
    function search(keyT, a, b, arr) {
        let i, j;

        if (a === 'J')
            a = 'I';
        else if (b === 'J')
            b = 'I';

        for (i = 0; i < 5; i++) {

            for (j = 0; j < 5; j++) {

                if (keyT[i][j] === a) {
                    arr[0] = i;
                    arr[1] = j;
                }
                else if (keyT[i][j] === b) {
                    arr[2] = i;
                    arr[3] = j;
                }
            }
        }
        return arr;
    }

    // Function to find the modulus with 5
    function mod5(a) {
        return (a % 5);
    }

    function checkRepeats(str, ps) {
        let i;
        let newStr = "";
        let tempStr = str
        tempStr = tempStr.replace(/J/g, 'I')
        console.log("After replacing I with J : ", tempStr)
        for (i = 0; i < ps; i += 2) {
            if (tempStr[i] === tempStr[i + 1]) {
                let j;
                let k;
                for (j = 0; j <= i; j++) {
                    newStr += str[j]
                }
                newStr += 'X'
                for (k = i + 1; k < ps; k++) {
                    newStr += str[k]
                }
                str = newStr
                tempStr = newStr
            }
        }
        // console.log("After removing repeats : ", str)
        return str
    }

    // Function to make the plain text length to be even
    function prepare(str, ptrs) {

        str = checkRepeats(str, ptrs)

        if (str.length % 2 !== 0) {
            str += 'Z';
        }

        // console.log("After adding Z :", str)

        return [str, str.length];
    }

    // Function for performing the encryption
    function encrypt(str, keyT, ps) {
        let i;
        let a = new Array(4).fill(0);
        let newstr = new Array(ps);

        for (i = 0; i < ps; i += 2) {
            let brr = search(keyT, str[i], str[i + 1], a);
            let k1 = brr[0];
            let k2 = brr[1];
            let k3 = brr[2];
            let k4 = brr[3];
            if (k1 === k3) {
                newstr[i] = keyT[k1][(k2 + 1) % 5];
                newstr[i + 1] = keyT[k1][(k4 + 1) % 5];
            }
            else if (k2 === k4) {
                newstr[i] = keyT[(k1 + 1) % 5][k2];
                newstr[i + 1] = keyT[(k3 + 1) % 5][k2];
            }
            else {
                newstr[i] = keyT[k1][k4];
                newstr[i + 1] = keyT[k3][k2];
            }
            const newStep = [str[i], str[i + 1], newstr[i], newstr[i + 1]];
            addEncStep(newStep)
            // console.log("stepsssss : ")
            // console.log([str[i], str[i + 1], newstr[i], newstr[i + 1]])
            // console.log(encSteps)
        }
        let res = "";

        for (let i = 0; i < newstr.length; i++) { res += newstr[i]; }
        setResult(res);
        setIsSimulating(false);
        return res;
    }

    // Function to encrypt using Playfair Cipher
    function encryptByPlayfairCipher(str, key) {
        setKey(key)

        let ps, ks;
        let keyT = new Array(5);

        for (let i = 0; i < 5; i++) {
            keyT[i] = new Array(5);
        }

        str = str.trim();
        key = key.trim();
        str = str.toUpperCase();
        str = str.replace(/J/g, 'I')

        key = key.toUpperCase();
        key = key.replace(/J/g, 'I')
        ps = str.length;
        ks = key.length;
        [str, ps] = prepare(str, ps);

        let kt = generateKeyTable(key, ks, keyT);
        return encrypt(str, kt, ps);
    }

    // *** Encryption END ***

    // *** Decryption START ***

    function toUpperCase(plain) {
        return plain.toUpperCase();
    }

    function removeSpaces(plain) {
        return plain.split(' ').join('');
    }

    function decrypt(str, keyT) {
        // Function to decrypt
        var ps = str.length;


        let i;
        let a = new Array(4).fill(0);
        let newstr = new Array(ps);

        for (i = 0; i < ps; i += 2) {
            let brr = search(keyT, str[i], str[i + 1], a);
            let k1 = brr[0];
            let k2 = brr[1];
            let k3 = brr[2];
            let k4 = brr[3];
            if (k1 === k3) {
                newstr[i] = keyT[k1][((k2 - 1) < 0 ? (5 + (k2 - 1)) : (k2 - 1)) % 5];
                newstr[i + 1] = keyT[k1][((k4 - 1) < 0 ? (5 + (k4 - 1)) : (k4 - 1)) % 5];
            }
            else if (k2 === k4) {
                newstr[i] = keyT[((k1 - 1) < 0 ? (5 + (k1 - 1)) : (k1 - 1)) % 5][k2];
                newstr[i + 1] = keyT[((k3 - 1) < 0 ? (5 + (k3 - 1)) : (k3 - 1)) % 5][k2];
            }
            else {
                newstr[i] = keyT[k1][k4];
                newstr[i + 1] = keyT[k3][k2];
            }
            const newStep = [str[i], str[i + 1], newstr[i], newstr[i + 1]];
            addDecStep(newStep)
            console.log("Decryption Step : ", newStep)
        }
        let res = "";

        for (let i = 0; i < newstr.length; i++) { res += newstr[i]; }
        setDecryptedtResult(res);
        return res;
    }

    function decryptByPlayfairCipher(str, key) {
        key = removeSpaces(toUpperCase(key));
        str = removeSpaces(toUpperCase(str));
        var keyT = kTab;
        return decrypt(str, keyT);
    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();

        if (!isSimulating){
            setIsSimulating(true);
            // Read the form data
            const form = e.target;
            const formData = new FormData(form);

            // You can pass formData as a fetch body directly:
            // fetch('/some-api', { method: form.method, body: formData });

            // Or you can work with it as a plain object:
            const formJson = Object.fromEntries(formData.entries());
            // console.log(formJson);
            setOriginalPlainText(formData.get("plaintext").toUpperCase())
            var resEnc = encryptByPlayfairCipher(formData.get("plaintext").toUpperCase(), formData.get("key").toUpperCase());
            var resDec = decryptByPlayfairCipher(resEnc, formData.get("key").toUpperCase());
            setClickedSimulate(true)
            console.log(resEnc);
            console.log(resDec);
        }

    }

    return (
        <>
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="plaintext" />
                </label>
                <label>
                    Key (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="key" />
                </label>
                <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' disabled={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</Button> */}
            </form>
            <br />
            <div style={{ display: keyTable.length === 0 ? "none" : "block" }} >
                <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 30px 0" }}>Key Table</p>
                <PlayfairTable selectedPlain={""} selectedCipher={""} keyTable={keyTable} />
                <br />
            </div>

            <div style={{ display: clickedSimulate ? "block" : "none" }} >
                <p style={{ fontSize: 17 }}><span style={{ fontWeight: "bold" }}>Original Plain Text :</span>{originalPlainText}</p>
                <p style={{ fontSize: 17 }}><span style={{ fontWeight: "bold" }}>Processed Plain Text :</span>{decryptedResult}</p>
                <PlayfairCipherEncryption steps={encSteps} shift={key} keyTable={keyTable} result={finalResult} />
            </div>
            <div style={{ display: clickedSimulate ? "block" : "none" }} >
                <hr />
                <PlayfairCipherDecryption steps={decSteps} shift={key} keyTable={keyTable} result={decryptedResult} />
            </div>
        </>
    )
}

export default PlayfairCipherSimulation